import { z } from "zod";

/** Platform-neutral data rendered by a profile hero. */
export const profileHeroSchema = z.object({
  imageUrl: z.string().nullable().optional(),
  title: z.string().min(1),
});

export type ProfileHeroValue = z.infer<typeof profileHeroSchema>;
